var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.9C14.28 6.9 14.94 7.75 15 9H17.21C17.14 7.28 16.09 5.7 14 5.19V3H11V5.16C10.47 5.28 9.97 5.46 9.52 5.7L10.99 7.17C11.4 7 11.9 6.9 12.5 6.9ZM5.33 4.06L4.06 5.33L7.5 8.77C7.5 10.85 9.06 11.98 11.41 12.68L14.92 16.19C14.58 16.67 13.87 17.1 12.5 17.1C10.44 17.1 9.63 16.18 9.52 15H7.32C7.44 17.19 9.08 18.42 11 18.83V21H14V18.85C14.96 18.67 15.82 18.3 16.45 17.73L18.67 19.95L19.94 18.68L5.33 4.06Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.f20bf8451a9b7360215e5df046d56656.svg";
export { ForwardRef as ReactComponent };